import * as Types from '@aeppic/types'

export const VALIDATION_STAMP_TYPE = '762fa755-443c-4ea8-955e-b1af4c5166e8'
export const VALIDATION_RESULT_FORM = 'ae80e40e-ff4d-4964-8e78-ab3b9d76f47d'
export type StampedValidationStatus = 'PASSED' | 'FAILED' | 'ERROR' | 'PENDING'
export type ValidationCertificate = {
  ruleId: string
  ruleKey: string
  configuration: string
  checkedAt: string
  outcome: 'PASSED' | 'FAILED' | 'ERROR'
  resultJson: string
}

/** Includes referenced executable versions, not just the containing rule version. */
export async function validationConfiguration(api: any, rule: Types.Document, form: Types.Document, params: object = {}): Promise<string> {
  const versions = [form.id + '@' + form.v, rule.id + '@' + rule.v]
  const data = rule.data as any
  const refs = data?.actions?.length ? data.actions : data?.action?.id ? [data.action] : []
  for (const ref of refs) {
    const action = await api.get(ref)
    if (!action) { versions.push(String(ref.id || ref) + '@MISSING'); continue }
    versions.push(action.id + '@' + action.v)
    for (const packageRef of action.data?.packages || []) {
      const pkg = await api.get(packageRef)
      if (!pkg) { versions.push(packageRef.id + '@MISSING'); continue }
      versions.push(pkg.id + '@' + pkg.v)
    }
  }
  return JSON.stringify({ versions, params: canonical(params) })
}
function canonical(value: any): any {
  if (Array.isArray(value)) return value.map(canonical)
  if (value && typeof value === 'object') return Object.fromEntries(Object.keys(value).sort().map(key => [key, canonical(value[key])]))
  return value
}

export async function readValidationCertificate(api: any, target: Types.Document, rule: Types.Document, configuration: string) {
  const stamp = target.stamps?.find(s => s.workflowUid === 'validation:' + rule.id && s.type?.id === VALIDATION_STAMP_TYPE)
  if (!stamp || stamp.targetVersion !== target.v) return null
  const document = await api.get(stamp.id)
  if (document?.stampData?.documents?.[0]?.v !== target.v) return null
  try {
    const additional = JSON.parse(document.data.additionalData)
    const certificate = additional.data as ValidationCertificate
    if (additional.f?.id !== VALIDATION_RESULT_FORM || certificate.ruleId !== rule.id || certificate.configuration !== configuration) return null
    if (!['PASSED', 'FAILED', 'ERROR'].includes(certificate.outcome)) return null
    return { stamp, certificate, result: JSON.parse(certificate.resultJson) }
  } catch { return null }
}
